// ─── NAV SCROLL ────────────────────────────────────────
const nav = document.querySelector('.site-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });
}

// ─── MOBILE MENU ───────────────────────────────────────
const hamburger = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobileMenu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => mobileMenu.classList.toggle('open'));
}
window.closeMobileMenu = function() {
  if (mobileMenu) mobileMenu.classList.remove('open');
};

// ─── CART STATE ────────────────────────────────────────
let cartItems = [];

function updateCartUI() {
  const count = cartItems.reduce((sum, i) => sum + i.quantity, 0);
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.classList.toggle('hidden', count === 0);
  });
  const itemsEl = document.getElementById('cartItems');
  const totalEl = document.getElementById('cartTotal');
  if (!itemsEl) return;
  if (cartItems.length === 0) {
    itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
  } else {
    itemsEl.innerHTML = cartItems.map((item, idx) => `
      <div class="cart-item">
        <div class="cart-item-img-placeholder">${item.emoji || '🫙'}</div>
        <div>
          <div class="cart-item-name">${item.title}</div>
          <div class="cart-item-price">₹${item.price} × ${item.quantity}</div>
        </div>
        <button class="cart-item-remove" onclick="removeFromCart(${idx})">Remove</button>
      </div>
    `).join('');
  }
  if (totalEl) {
    const total = cartItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
    totalEl.textContent = '₹' + total;
  }
}

window.addToCartClient = function(variantId, title, price, emoji) {
  // Try Shopify AJAX cart first
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(data => {
    if (data.id) {
      const existing = cartItems.find(i => i.variantId === variantId);
      if (existing) { existing.quantity++; }
      else { cartItems.push({ variantId, title, price, quantity: 1, emoji }); }
      updateCartUI();
      showToast('✓ ' + title + ' added to cart');
      openCart();
    }
  })
  .catch(() => {
    // Fallback for static/preview context
    const existing = cartItems.find(i => i.variantId === variantId);
    if (existing) { existing.quantity++; }
    else { cartItems.push({ variantId, title, price, quantity: 1, emoji }); }
    updateCartUI();
    showToast('✓ ' + title + ' added to cart');
    openCart();
  });
};

window.removeFromCart = function(idx) {
  const item = cartItems[idx];
  if (!item) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: item.variantId, quantity: 0 })
  }).catch(() => {});
  cartItems.splice(idx, 1);
  updateCartUI();
};

// ─── CART DRAWER ───────────────────────────────────────
function openCart() {
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('open');
}
window.openCart = openCart;
window.closeCart = function() {
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('open');
};
document.getElementById('cartOverlay')?.addEventListener('click', window.closeCart);

// ─── TOAST ─────────────────────────────────────────────
function showToast(msg) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 2800);
}
window.showToast = showToast;

// ─── NEWSLETTER ────────────────────────────────────────
const newsletterForm = document.getElementById('newsletterForm');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', e => {
    e.preventDefault();
    showToast('🎉 You\'re on the list! Watch your inbox.');
    e.target.reset();
  });
}

// ─── FADE-IN ON SCROLL ─────────────────────────────────
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
